export const DepartmentsInventoryColumns = [
  {
    Header: 'Item Name',
    accessor: 'name',
  },
  {
    Header: 'Descrption',
    accessor: 'description',
  },
  // {
  //   Header: "Department",
  //   accessor: "department",
  // },
  {
      Header: 'Category',
      accessor: 'category',
  },
  {
    Header: "Quantity",
    accessor: "quantity",
  },
  {
    Header: "Unit",
    accessor: "unit",
  },
  {
    Header: "Price-Per Unit",
    accessor: "cost_per_unit",
  },
  {
    Header: 'Actions',
    accessor: 'actions',
  }
];
